import { usePage } from '@inertiajs/react';
import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const SvgIcon = forwardRef(function SvgIcon(
    { testid = 'svg-icon', className = '', collectionName, iconId, ...rest },
    ref
) {
    let version = '';

    try {
        version = usePage().props.current_commit_hash;
    } catch (error) {
        console.warn(error);
        version = 'static';
    }

    return (
        <svg data-testid={testid} ref={ref} className={`size-6 ${className}`} {...rest}>
            <use
                xlinkHref={`/assets/images/svg/new-icons/${collectionName}.svg?v=${version}#${iconId}`}
            />
        </svg>
    );
});

SvgIcon.propTypes = {
    className: PropTypes.string,
    iconId: PropTypes.string.isRequired,
    collectionName: PropTypes.string.isRequired,
};

export default SvgIcon;
